export const FORM_ROOT = 'form/';

// Actions types
export const GET_FORM_HEADERS = 'getFormHeaders';
export const GET_FORM101_DATA = 'getFormData';
export const EDIT_EXISTING_FORM = 'editExistingForm';
export const COMPARE_EMPLOYEE_DETAILS = 'compareEmployeeDetails';
export const DELETE_FORM_WITH_CHANGES = 'deleteFormWithChanges';
export const CREATE_NEW_FORM = 'createNewForm';
export const REINIT_AUTHENTICATION_TOKEN = 'reinitAuthenticationToken';
export const SUBMIT_FORM = 'submitForm';
export const SAVE_AS_DRAFT = 'saveAsDraft';
export const GET_CITIES = 'getAllCitiesList';
export const GET_SETTLEMENTS = 'getSettlementsList';
export const GET_FORM101_AS_PDF = 'getForm101AsPdf';
export const GENERATE_FORM_101_AS_PDF = 'generateForm101AsPdf';
export const CHECK_MISSING_DOCUMENTS = 'checkMissingDocuments';
export const UPDATE_USER_OFFICE = 'updateUserOffice';
export const DOWNLOAD_FORM_119 = 'download119Form';

// Getters types
export const FORM_HEADERS = 'formHeaders';
export const FORM101_DATA = 'Form101Data';
export const FORM101_META_DATA = 'Form101MetaData';
export const FORM101_ID = 'Form101Id';
export const FORM_READ_ONLY_MODE = 'formReadOnlyMode';
export const EMPLOYER_DETAILS = 'EMPLOYER_DETAILS';
export const CITIES = 'cities';
export const SETTLEMENTS = 'settlements';
export const FORM_LOADING_MODE = 'formLoadingMode';
export const FORM_SUCCESS_DIALOG = 'formSuccessDialog';
export const OPEN_CONFIRM_FORM_DIALOG = 'openConfirmFormDialog';
export const OPEN_APPROVE_FORM_DIALOG = 'openApproveFormDialog';
export const OPEN_REJECT_FORM_DIALOG = 'openRejectFormDialog';
export const OPEN_FORM_STATUS_HISTORY_DIALOG = 'openFormStatusHistoryDialog';
export const OPEN_FORM_101_CHANGES_DIALOG = 'openForm101ChangesDialog';
export const SUBMIT_FORM_ERRORS = 'submitFormErrors';
export const FORM_ERRORS = 'formErrors';
export const CREATE_FORM_ERRORS = 'createFormErrors';
export const EDIT_FORM_ERRORS = 'editFormErrors';
export const NO_PDF_ERROR = 'noPdfError';
export const NO_PDF_ERRORS = 'noPdfErrors';
export const WIZARD_HEADER_TITLE = 'wizardHeaderTitle';
export const TOOLTIP_ID = 'tooltipId';
export const FORM_ERRORS_OPEN = 'formErrorsOpen';
export const FORM_ERRORS_SHOW = 'formErrorsShow';
export const OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL = 'openSaveBeforeLeaveWizardModal';
export const SAVE_BEFORE_LEAVE_WIZARD_ROUTE_NAME = 'saveBeforeLeaveWizardRouteName';
export const SKIP_SAVE_BEFORE_LEAVE_WIZARD_MODAL = 'skipSaveBeforeLeaveWizardModal';
export const DELETE_FORM_ERRORS = 'deleteFormErrors';
export const FORM_REJECTED_REASON = 'formRejectedReason';
export const OPEN_CHOOSE_FORM_OFFICE_MODAL = 'openChooseFormOfficeModal';
export const CREATE_FORM_LOADING = 'createFormLoading';
export const COMPARE_EMPLOYEE_DETAILS_ERRORS = 'compareEmployeeDetailsErrors';
export const OPEN_DELETE_FORM_MODAL = 'openDeleteFormModal';
export const APPROVE_DETAILS_CHANGES = 'approveDetailsChanges';
export const OPEN_CHANGES_NOTIFICATION_MODAL = 'openChangesNotificationModal';

// Mutations types
export const SET_FORM_HEADERS = 'setFormHeaders';
export const SET_FORM101_DATA = 'setForm101Data';
export const SET_FORM101_META_DATA = 'setForm101MetaData';
export const SET_FORM101_ID = 'setForm101Id';
export const SET_CITIES = 'setCities';
export const SET_SETTLEMENTS = 'setSettlements';
export const ADD_EMPLOYEE_CHILD = 'addEmployeeChild';
export const REMOVE_EMPLOYEE_CHILD = 'removeEmployeeChild';
export const UPDATE_EMPLOYEE_CHILD_DETAILS = 'updateEmployeeChildDetails';
export const RESET_EMPLOYEE_DETAILS = 'resetEmployeeDetails';
export const SET_WIZARD_HEADER_TITLE = 'setWizardHeaderTitle';
export const SET_FORM_READ_ONLY_MODE = 'setFormReadOnlyMode';
export const SET_FORM_LOADING_MODE = 'setFormLoadingMode';
export const SET_FORM_SUCCESS_DIALOG = 'setFormSuccessDialog';
export const SET_OPEN_CONFIRM_FORM_DIALOG = 'setOpenConfirmFormDialog';
export const SET_OPEN_APPROVE_FORM_DIALOG = 'setOpenApproveFormDialog';
export const SET_OPEN_REJECT_FORM_DIALOG = 'setOpenRejectFormDialog';
export const SET_OPEN_FORM_STATUS_HISTORY_DIALOG = 'setOpenFormStatusHistoryDialog';
export const SET_OPEN_FORM_101_CHANGES_DIALOG = 'setOpenForm101ChangesDialog';
export const SET_SUBMIT_FORM_ERRORS = 'setSubmitFormErrors';
export const SET_CREATE_FORM_ERRORS = 'setCreateFormErrors';
export const SET_EDIT_FORM_ERRORS = 'setEditFormErrors';
export const SET_NO_PDF_ERROR = 'setNoPdfError';
export const SET_NO_PDF_ERRORS = 'setNoPdfErrors';
export const SET_FORM_ERRORS = 'setFormErrors';
export const RESET_FORM_ERRORS = 'resetFormErrors';
export const FORM_RESET_STATE = 'formResetState';
export const SET_TOOLTIP_ID = 'setTooltipId';
export const SET_FORM_ERRORS_OPEN = 'setFormErrorsOpen';
export const SET_FORM_ERRORS_SHOW = 'setFormErrorsShow';
export const SET_OPEN_SAVE_BEFORE_LEAVE_WIZARD_MODAL = 'setOpenSaveBeforeLeaveWizardModal';
export const SET_SAVE_BEFORE_LEAVE_WIZARD_ROUTE_NAME = 'setSaveBeforeLeaveWizardRouteName';
export const SET_SKIP_SAVE_BEFORE_LEAVE_WIZARD_MODAL = 'setSkipSaveBeforeLeaveWizardModal';
export const SET_DELETE_FORM_ERRORS = 'setDeleteFormErrors';
export const SET_FORM_REJECTED_REASON = 'setFormRejectedReason';
export const SET_OPEN_CHOOSE_FORM_OFFICE_MODAL = 'setOpenChooseFormOfficeModal';
export const SET_CREATE_FORM_LOADING = 'setCreateFormLoading';
export const ADD_EXTERNAL_INCOME = 'addExternalIncome';
export const REMOVE_EXTERNAL_INCOME = 'removeExternalIncome';
export const UPDATE_EXTERNAL_INCOME = 'updateExternalIncome';
export const SET_OPEN_DELETE_FORM_DIALOG = 'setOpenDeleteFormDialog';
export const SET_APPROVE_DETAILS_CHANGES = 'setApproveDetailsChanges';
export const SET_OPEN_CHANGES_NOTIFICATION_MODAL = 'setOpenChangesNotificationModal';
